import { Disease } from '@interfaces/disease.interface';

import api from './';

export const { useGetDiseasesQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getDiseases: build.query<Disease[], void>({
      query: () => ({ url: 'disease' }),
    }),
  }),
});
